import DTO from './DTO';
import {
  inn10,
  maxLength12, maxLength15, minLength10, minLength13,
  noLetters, noSpaceEnd,
  noSpaceStart, ogrn13,
  onlyDigits, onlyDigitsAndLetters,
  required,
  trimError,
  trimNoSpecStartOrEnd,
  hasValidSpacesOrQuotes, ogrnIp15,
} from '../utils/validation';
import { USER_TYPE } from '../configs';

class JuridicalDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'legal_entity_form',
        type: String,
        validators: [required],
        labelKey: 'legal_entity_form',
      },
      {
        name: 'full_name',
        type: String,
        validators: [required, hasValidSpacesOrQuotes],
        labelKey: 'full_name_legal',
      },
      {
        name: 'short_name',
        type: String,
        validators: [required, hasValidSpacesOrQuotes],
        labelKey: 'short_name_legal',
      },
      {
        name: 'inn',
        type: String,
        validators: [required, onlyDigits, noLetters, trimError, trimNoSpecStartOrEnd, noSpaceStart, noSpaceEnd, inn10],
        labelKey: 'inn',
      },
      {
        name: 'ogrn',
        type: String,
        validators: [required, onlyDigitsAndLetters, trimError, trimNoSpecStartOrEnd, noSpaceStart, noSpaceEnd, params?.legal_entity_type === USER_TYPE.LEGAL ? ogrn13 : ogrnIp15],
        labelKey: 'ogrn',
      },
      {
        name: 'address',
        type: String,
        validators: {},
        labelKey: 'address_location',
      },
      {
        name: 'legal_address',
        type: String,
        validators: [required],
        labelKey: 'legal_address',
      },
      {
        name: 'phone',
        type: String,
        validators: [required],
        labelKey: 'phone',
      },
      {
        name: 'email',
        type: String,
        validators: {},
        labelKey: 'pd.email',
      },
      {
        name: 'representative_identity_files',
        type: String,
        validators: [required],
        labelKey: 'identity_files',
        couldBeNull: true,
      },
      {
        name: 'isMatch',
        type: Boolean,
        validators: [],
        labelKey: 'isMatch',
        couldBeNull: true,
      },
      {
        name: 'applicant_identity_files',
        type: String,
        validators: [],
        labelKey: 'identity_files',
        couldBeNull: true,
      },
      {
        name: 'identity_change_document',
        type: String,
        validators: [],
        labelKey: 'media.identity_change_document',
      },
      {
        name: 'address_change_document',
        type: String,
        validators: [],
        labelKey: 'media.address_change_document',
      },
      {
        name: 'ogrn_change_document',
        type: String,
        validators: [],
        labelKey: 'media.ogrn_change_document',
      },
      {
        name: 'ogrip_change_document',
        type: String,
        validators: [],
        labelKey: 'media.ogrip_change_document',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      legal_entity_form: this.legal_entity_form,
      full_name: this.full_name,
      short_name: this.short_name,
      inn: this.inn,
      ogrn: this.ogrn,
      address: this.address,
      legal_address: this.legal_address,
      phone: this.phone,
      email: this.email,
    };
  }
}

export default JuridicalDTO;
